import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    external_rd_id: Yup.string().required("This field is required"),
    fax_number: Yup.string()
      .nullable()
      .required("This field is required")
  }),
  mapPropsToValues: props => ({
    external_rd_id: "",
    fax_number: ""
  }),
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
